// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-products-modal ::ng-deep .mat-mdc-tab-body-content{overflow:hidden;height:37vh}.filter-products-modal .body{position:relative;padding-top:20px;overflow-x:hidden;overflow-y:auto;height:calc(100% - 50px);max-height:500px}.filter-products-modal .body ul{padding-left:0;list-style:none}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
